<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
// import eruda from 'eruda'

export default {
  mounted() {
    // eruda.init()
  }
}

</script>

<style lang="scss">
</style>
